import { ProButton } from '@/components/Buttons/ProButton'
import LeftArrowIcon from '@/CustomIcons/LeftArrowIcon'
import TutorialIcon from '@/CustomIcons/TutorialIcon'
import ElectronIPC from '@/services/ElectronIPC'
import { useIsProUser } from '@/services/useIsProUser'
import { Button } from '@/UIComponents2/Button'
import { cn } from '@/utlis/cn'
import { useHistory } from 'react-router-dom'
import * as Constants from '@/services/Constants'
import { useTranslation } from 'react-i18next'
import { carmackClick } from '@/utils'

type TopBarProps = {
    className?: string
}
export function TopBar({ className }: TopBarProps) {
    const { t } = useTranslation()
    const history = useHistory()
    const isProUser = useIsProUser()

    const handleGoBack = () => {
        if (history.length > 1) {
            history.goBack()
        } else {
            history.replace('/')
        }
    }

    const handleOpenTutorials = () => {
        ElectronIPC.openLinkInBrowser(Constants.links.zendesk_tutorials)
    }

    return (
        <div className={cn('flex justify-between items-center', className)}>
            <div className="flex items-center gap-[60px]">
                <Button
                    variant="secondary"
                    className="relative px-10 py-0 h-[40px]"
                    onMouseDown={carmackClick(() => handleGoBack())}
                >
                    <LeftArrowIcon className="absolute left-3" />
                    {t('Back')}
                </Button>
            </div>
            <div className="flex items-center gap-8">
                <Button
                    onClick={() => handleOpenTutorials()}
                    className="flex gap-2 items-center opacity-75 hover:opacity-100"
                >
                    <TutorialIcon />
                    {t('Tutorials')}
                </Button>
                {!isProUser && <ProButton>{t('Upgrade to Pro')}</ProButton>}
            </div>
        </div>
    )
}
